<template>
    <div class="auto-reply-button-group mt-1 mb-75">
        <b-button type="button" variant="flat-secondary" @click="showEmojiPicker = true">
            <font-awesome-icon :icon="['fa', 'laugh']" class="cursor-pointer" size="1x" />
        </b-button>
        <div ref="emojiPicker" class="emoji-picker">
            <!-- prevents onClickOutside closing on interacting with emojiPicker -->
            <VEmojiPicker v-if="showEmojiPicker" @select="selectEmoji" />
        </div>

        <variable-picker :exclude="['agent', 'assignedAgent']" @select="$emit('selected-variable', $event)" />

        <div v-b-tooltip.hover.bottom="allowFiles ? '' : $t('sms-no-assets-allowed')" class="d-inline-block">
            <b-button :disabled="!allowFiles" class="ml-1" type="button" variant="primary" @click="openFilePrompt()">
                <b-form-file
                    v-show="false"
                    :id="`files-${id}`"
                    ref="imageInput"
                    accept="image/*, video/*, audio/*, application/pdf, text/csv"
                    @input="$emit('set-file', $event)"
                />
                {{ $t("settings.channels.files.choose") }}
            </b-button>
        </div>
        <div class="ml-1 d-inline-block">
            <div v-if="selectedFilename">
                <font-awesome-icon class="text-success" icon="circle-check" />
                {{ selectedFilename }}
                <font-awesome-icon class="cursor-pointer ml-1" icon="circle-xmark" @click="$emit('remove-file')" />
            </div>
            <div v-if="uploadingFile">
                <b-spinner class="mr-1" small></b-spinner>{{ $t("settings.channels.files.uploading") }}
            </div>
        </div>
    </div>
</template>
<script>
import { BButton, BButtonGroup, BDropdown, BDropdownItem, BFormFile, BSpinner, VBTooltip } from "bootstrap-vue";
import { ref } from "@vue/composition-api/dist/vue-composition-api";
import { VEmojiPicker } from "v-emoji-picker";
import { onClickOutside } from "@vueuse/core";
import VariablePicker from "@/components/variablePicker.vue";

export default {
    components: {
        BButton,
        BButtonGroup,
        BDropdown,
        BDropdownItem,
        BFormFile,
        BSpinner,
        VEmojiPicker,
        VariablePicker,
    },
    directives: {
        "b-tooltip": VBTooltip,
    },
    props: {
        id: {
            type: String,
            required: true,
        },
        selectedFilename: {
            type: String,
            required: false,
        },
        uploadingFile: {
            type: Boolean,
            required: true,
        },
        allowFiles: {
            type: Boolean,
            required: true,
        },
    },
    setup() {
        const emojiPicker = ref(null);
        const showEmojiPicker = ref(false);
        const imageInput = ref(null);

        onClickOutside(emojiPicker, () => (showEmojiPicker.value = false));

        const openFilePrompt = () => {
            imageInput.value.$el.children[0].click();
        };

        return {
            emojiPicker,
            showEmojiPicker,
            imageInput,

            openFilePrompt,
        };
    },
    methods: {
        selectEmoji(emoji) {
            this.showEmojiPicker = false;
            this.$emit("select-emoji", emoji);
        },
    },
};
</script>
